import React, { useEffect, useState } from "react";
import {
    Box,
    Drawer,
    List,
    ListItem,
    ListItemText,
    TextField,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Autocomplete,
    ToggleButton,
    ToggleButtonGroup,
    Button,
    IconButton
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import useApiManager from "../../utils/Api/apiManager";
import FieldsAutoComplete from "../../components/Reports/FieldsAutoComplete";
import { Modules } from "../../utils/enums";
import FilterModal from "../../components/Reports/FilterModal";
import { useNavigate } from "react-router-dom";

const CreateReport = () => {
    const [view, setView] = useState("columns"); // Default selected tab
    const [selectedModule, setSelectedModule] = useState(null);
    const [moduleFields, setModuleFields] = useState([]);
    const [moduleFilterFields, setModuleFilterFields] = useState([]);

    const [reportName, setReportName] = useState(null);
    const [selectedFields, setSelectedFields] = useState([]);
    const [filters, setFilters] = useState([]);


    const [filterModalOpen, setFilterModalOpen] = useState(false);
    const { get, post } = useApiManager();
    const navigate = useNavigate();

    const handleModuleChange = async (newValue) => {
        const selectedValue = newValue ? newValue.value : '';
        setSelectedModule(selectedValue);

        try {
            const data = await get(`/report-fields/${selectedValue}`);
            console.log(data);
            setModuleFields(data.fields);
            setModuleFilterFields(data.filters);
        }
        catch (error) {
            console.error("something went wrong: ", error);
        }
    };

    const handleDeleteFilter = (index) => {
        setFilters((prevFilters) => prevFilters.filter((_, i) => i !== index));
    };

    const handleSave = async () => {
        const reportData = {
            name: reportName, // Replace with actual name
            description: "", // Replace with actual description
            type: selectedModule, // Replace with actual type
            fields: selectedFields,
            filters: filters
        };

        try {
            const response = await post("/reports", reportData);
            console.log("Report saved successfully:", response);
            navigate("/reports");
        }
        catch (error) {
            console.log("Erorr saving report: ", error);
        }
    };

    const FilterOperator = Object.freeze([
        { value: 0, label: "Equal" },
        { value: 1, label: "Not Equal" },
        { value: 2, label: "Contains" },
        { value: 3, label: "Not Contains" },
        { value: 4, label: "Starts With" },
        { value: 5, label: "Ends With" },
        { value: 6, label: "Is Empty" },
        { value: 7, label: "Is Not Empty" },
        { value: 8, label: "Is Null" },
        { value: 9, label: "Is Not Null" },
        { value: 10, label: "Greater Than" },
        { value: 11, label: "Greater Than or Equal" },
        { value: 12, label: "Less Than" },
        { value: 13, label: "Less Than or Equal" },
        { value: 14, label: "Between" },
    ]);

    useEffect(() => {
        document.title = "Reports - iLead CRM";
    }, [])

    return (
        <Box sx={{ display: "flex" }}>
            {/* Sidebar */}
            <Box
                sx={{
                    height: "calc(100vh - 70px)",
                    width: 240,
                    bgcolor: "background.paper",
                    boxShadow: 1,
                    p: 2,
                    overflowY: "auto",
                }}
            >
                {/* Toggle Buttons */}
                <ToggleButtonGroup
                    value={view}
                    exclusive
                    onChange={(event, newView) => setView(newView)}
                    sx={{
                        width: "100%",
                        mb: 2,
                        border: "1px solid #ccc",
                        borderRadius: "20px", // Rounded border
                        overflow: "hidden",
                    }}
                >
                    <ToggleButton
                        value="columns"
                        sx={{
                            flex: 1,
                            textTransform: "none",
                            fontWeight: view === "columns" ? "bold" : "normal",
                            bgcolor: view === "columns" ? "rgba(33, 150, 243, 0.1)" : "transparent",
                            "&.Mui-selected": {
                                bgcolor: "rgba(33, 150, 243, 0.1)",
                                color: "black",
                            },
                        }}
                    >
                        Columns
                    </ToggleButton>
                    <ToggleButton
                        value="filters"
                        sx={{
                            flex: 1,
                            textTransform: "none",
                            fontWeight: view === "filters" ? "bold" : "normal",
                            bgcolor: view === "filters" ? "rgba(33, 150, 243, 0.1)" : "transparent",
                            "&.Mui-selected": {
                                bgcolor: "rgba(33, 150, 243, 0.1)",
                                color: "black",
                            },
                        }}
                    >
                        Filters
                    </ToggleButton>
                </ToggleButtonGroup>

                {/* Render Content Based on Selected Tab */}
                {view === "columns" && (
                    <>
                        <Autocomplete
                            disablePortal
                            options={Modules}
                            sx={{ width: "100%", mb: 1 }}
                            value={Modules.find((option) => option.value === selectedModule) || null}
                            onChange={(event, newValue) => handleModuleChange(newValue)}
                            renderInput={(params) => <TextField {...params} label="Select Module" size="small" />}
                        />
                        <FieldsAutoComplete options={moduleFields} selectedFields={selectedFields} setSelectedFields={setSelectedFields} />
                        {/* Selected Items List */}
                        {selectedFields.length > 0 && (
                            <List sx={{ marginTop: 2, border: "1px solid #ccc", borderRadius: 2, fontSize: "0.875rem" }}>
                                {selectedFields.map((option) => (
                                    <ListItem key={option.fieldName}>
                                        <ListItemText primary={option.displayName} primaryTypographyProps={{ variant: "body2" }} />
                                    </ListItem>
                                ))}
                            </List>
                        )}
                    </>
                )}

                {view === "filters" && (
                    <>
                        <Button size="small" onClick={() => setFilterModalOpen(true)}>+ Add filter</Button>
                        <FilterModal open={filterModalOpen} onClose={() => setFilterModalOpen(false)} moduleFields={moduleFilterFields} filters={filters} setFilters={setFilters} module={selectedModule} />

                        <div
                            onClick={() => setFilterModalOpen(true)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: '16px',
                                color: '#333',
                                fontWeight: 'bold',
                                cursor: 'pointer'
                            }}
                        >
                            <span>Applied Filters</span>
                            <span
                                style={{
                                    marginLeft: '8px',
                                    backgroundColor: '#E5EDFF',
                                    color: '#333',
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    padding: '4px 8px',
                                    borderRadius: '8px'
                                }}
                            >
                                {filters.length || 0}
                            </span>
                        </div>




                        {/* <List>
                            {filters.map((filter, index) => (
                                <ListItem
                                    key={index}
                                    secondaryAction={
                                        <IconButton edge="end" onClick={() => handleDeleteFilter(index)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    }
                                >
                                    <ListItemText
                                        primary={`${filter.fieldName} ${FilterOperator.find(op => op.value === filter.operator)?.label || filter.operator} ${filter.value}`}
                                    />
                                </ListItem>
                            ))}
                        </List> */}
                    </>
                )}
            </Box>

            {/* Main Content */}
            <Box sx={{ flexGrow: 1, p: 3 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                    <TextField
                        variant="standard"
                        placeholder="Choose a name..."
                        value={reportName}
                        onChange={(e) => setReportName(e.target.value)}
                        InputProps={{
                            disableUnderline: true,
                            sx: {
                                border: "none",
                                backgroundColor: "transparent",
                                fontSize: "1.25rem", // h6 font size (20px)
                                fontWeight: 600, // h6 font weight
                                '&:hover': { backgroundColor: "transparent" },
                                '&:focus': { backgroundColor: "transparent" }
                            },
                        }}
                        sx={{
                            flexGrow: 1, // Makes the input take the available space
                            "& .MuiInputBase-root": { border: "none" },
                            "& .MuiInputBase-input": {
                                border: "none",
                                backgroundColor: "transparent",
                                fontSize: "1.25rem", // h6 size
                                fontWeight: 600 // h6 weight
                            }
                        }}
                    />

                    <Button variant="contained" size="small" onClick={handleSave}>
                        Save
                    </Button>
                </Box>



                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {/* Show default columns only when no fields are selected */}
                                {selectedFields.length === 0 ? (
                                    <>
                                        <TableCell>Column 1</TableCell>
                                        <TableCell>Column 2</TableCell>
                                        <TableCell>Column 3</TableCell>
                                    </>
                                ) : (
                                    selectedFields.map((field) => (
                                        <TableCell key={field.fieldName}>{field.displayName}</TableCell>
                                    ))
                                )}
                            </TableRow>
                        </TableHead>

                    </Table>
                </TableContainer>
            </Box>
        </Box>
    );
};

export default CreateReport;
